module.exports = __webpack_public_path__ + "img/image9-1.877ae27e.jpeg";